import { Table } from "@tanstack/table-core";
import IconButton from "@mui/material/IconButton/IconButton";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import KeyboardDoubleArrowLeft from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRight from "@mui/icons-material/KeyboardDoubleArrowRight";

import { NumericalItems, StyledPagination } from "./styled";

interface PaginationProps {
  table: Table<unknown>;
}

export const Pagination = ({ table }: PaginationProps) => {
  if (table.getPageCount() === 1) return <></>;

  return (
    <StyledPagination>
      <IconButton
        onClick={() => table.setPageIndex(0)}
        disabled={!table.getCanPreviousPage()}
      >
        <KeyboardDoubleArrowLeft />
      </IconButton>

      <IconButton
        onClick={() => table.previousPage()}
        disabled={!table.getCanPreviousPage()}
      >
        <KeyboardArrowLeft />
      </IconButton>

      {table.getPageCount() <= 6
        ? Array.from({ length: table.getPageCount() }, (_, i) => {
            return (
              <NumericalItems
                active={table.getState().pagination.pageIndex === i}
                key={i}
                onClick={() => table.setPageIndex(i)}
              >
                {i + 1}
              </NumericalItems>
            );
          })
        : null}

      {table.getPageCount() > 6
        ? Array.from({ length: table.getPageCount() }, (_, i) => {
            const currentIndex = table.getState().pagination.pageIndex;

            // always first and last 2 items
            if (i === 0 || i === table.getPageCount() - 1) {
              return (
                <NumericalItems
                  active={currentIndex === i}
                  key={i}
                  onClick={() => table.setPageIndex(i)}
                >
                  {i + 1}
                </NumericalItems>
              );
            }

            // display numbers besides the active pageIndex
            if (i === currentIndex || i === currentIndex - 1 || i === currentIndex + 1) {
              return (
                <NumericalItems
                  active={currentIndex === i}
                  key={i}
                  onClick={() => table.setPageIndex(i)}
                >
                  {i + 1}
                </NumericalItems>
              );
            }

            if (i === currentIndex) {
              return (
                <NumericalItems
                  active={currentIndex === i}
                  key={i}
                  onClick={() => table.setPageIndex(i)}
                >
                  {i + 1}
                </NumericalItems>
              );
            }

            if (i === currentIndex + 2 || i === currentIndex - 2) {
              return (
                <NumericalItems
                  active={currentIndex === i}
                  key={i}
                  onClick={() => table.setPageIndex(i)}
                >
                  ...
                </NumericalItems>
              );
            }
          })
        : null}

      <IconButton onClick={() => table.nextPage()} disabled={!table.getCanNextPage()}>
        <KeyboardArrowRight />
      </IconButton>

      <IconButton
        onClick={() => table.setPageIndex(table.getPageCount() - 1)}
        disabled={!table.getCanNextPage()}
      >
        <KeyboardDoubleArrowRight />
      </IconButton>
    </StyledPagination>
  );
};
